<div fxFlex=100 class="premiereImageDiv" fxLayout="row wrap">
        
        
    <div  class="backButton" fxLayout="row">
            <img src="assets/images/cinejoy/arrow-left.png" alt="" (click)="back()">
    </div>

    <div  class="mobile_cart" *ngIf="agilePurchaseEnabled">
        <app-shopping-cart ></app-shopping-cart>
    </div> 
    
    <div  fxLayout="row"  class="premiereMainImage">
        <img fxFlex=100 src="{{mobilePremiereDetails.mobilethumbimage}}" alt="">
    </div>
    
                        
    <div class="cinequestLogo" fxLayout="row" >
        <img class="logo" src="assets/images/spotlight/Laurel.png"/>
    </div>                                   
    
</div>


